import parseISO from 'date-fns/parseISO';
import { Filter } from 'model/Filters';
import AgendaPopoverContainer from 'modules/common/Popovers/AgendaPopover/AgendaPopoverContainer';
import FilterPopoverTrigger from 'modules/common/Popovers/FilterPopoverTrigger';
import usePopoverTrigger from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import React from 'react';
import FormatUtils from 'utils/FormatUtils';

interface AgendaPopoverTriggerProps {
  filters: {
    activeFilters: Filter[];
  };
}

function AgendaPopoverTrigger({ filters }: AgendaPopoverTriggerProps) {
  const { show, togglePopover, closePopover } = usePopoverTrigger('date');

  const dateFrom = filters.activeFilters.find(
    (filter) => filter.uid === 'date.from',
  )?.value;
  const dateTo = filters.activeFilters.find(
    (filter) => filter.uid === 'date.to',
  )?.value;

  return (
    <FilterPopoverTrigger
      destination="/filter/date/"
      text={FormatUtils.getDateText(filters)}
      togglePopover={togglePopover}
      isActive={filters.activeFilters.some(
        (filter) => filter.uid === 'date.from' && filter.value,
      )}
      show={show}
    >
      <AgendaPopoverContainer
        initialDateFrom={dateFrom ? parseISO(dateFrom) : null}
        initialDateTo={dateTo ? parseISO(dateTo) : null}
        onClose={closePopover}
      />
    </FilterPopoverTrigger>
  );
}

export default AgendaPopoverTrigger;
